import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../redux/store";

import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import Rooms from './pages/RoomsPage';
import Login from './pages/LoginPage';
import Logout from './pages/LogoutPage';
import LoadPage from "./pages/LoadPage";
import NotFound from "./pages/NotFoundPage";
import Loader from "./Loader";

const useStyles = makeStyles({
  root: {
    boxSizing: "border-box",
    minHeight: "100vh",
    paddingLeft: "15px",
    paddingRight: "15px"
  },
});

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

const AppRoutes = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Switch>
      <Route path="/login">
        {isAuthenticated ? <Redirect to="/load" /> : <Login />}
      </Route>
      <PrivateRoute exact path="/" component={Rooms} />
      <PrivateRoute path="/load" component={LoadPage} />
      <PrivateRoute path="/logout" component={Logout} />
      <Route component={NotFound} />
    </Switch>
  );
};

const App = () => {
  const styles = useStyles();
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className={styles.root}>
          <Loader />
          <HashRouter>
            <AppRoutes />
          </HashRouter>
        </div>
      </PersistGate>
    </Provider>
  );
};

export default App;
